// mutations
const PAPELERIA_DELIVERIES_ALL = (state, papeleriaDeliveries) => {
  if (papeleriaDeliveries.code === 1) {
    state.papeleriaDeliveries = papeleriaDeliveries.data
    state.status = 'success'
  } else {
    alert(papeleriaDeliveries.message)
    state.status = 'error'
  }
}

const PAPELERIA_DELIVERIES_FORM = (state, papeleriaDeliveries) => {
  if (papeleriaDeliveries.code === 1) {
    state.papeleriaDeliveries = papeleriaDeliveries.data
    state.status = 'success'
  } else {
    alert(papeleriaDeliveries.message)
    state.status = 'error'
  }
}

const PAPELERIA_DELIVERIES_SHOW = (state, papeleriaDeliveries) => {
  if (papeleriaDeliveries.code === 1) {
    state.deliveries = papeleriaDeliveries.data
    state.status = 'success'
  } else {
    alert(papeleriaDeliveries.message)
    state.status = 'error'
  }
}

const PAPELERIA_DELIVERIES_CREATE = (state, papeleriaDeliveries) => {
  if (papeleriaDeliveries.code === 1) {
    state.papeleriaDeliveries = papeleriaDeliveries.data
    state.status = 'success'
    alert(papeleriaDeliveries.message)
  } else {
    alert(papeleriaDeliveries.message)
    state.status = 'error'
  }
}

const PAPELERIA_DELIVERIES_UPDATE = (state, papeleriaDeliveries) => {
  if (papeleriaDeliveries.code === 1) {
    state.papeleriaDeliveries = papeleriaDeliveries.data
    state.status = 'success'
    alert(papeleriaDeliveries.message)
  } else {
    alert(papeleriaDeliveries.message)
    state.status = 'error'
  }
}

const PAPELERIA_DELIVERIES_DELETE = (state, papeleriaDeliveries) => {
  if (papeleriaDeliveries.code === 1) {
    state.papeleriaDeliveries = papeleriaDeliveries.data
    state.status = 'success'
    alert(papeleriaDeliveries.message)
  } else {
    alert(papeleriaDeliveries.message)
    state.status = 'error'
  }
}

export default {
  PAPELERIA_DELIVERIES_ALL,
  PAPELERIA_DELIVERIES_FORM,
  PAPELERIA_DELIVERIES_SHOW,
  PAPELERIA_DELIVERIES_CREATE,
  PAPELERIA_DELIVERIES_UPDATE,
  PAPELERIA_DELIVERIES_DELETE
}



// WEBPACK FOOTER //
// ./src/store/modules/papeleria/deliveries/mutations.js